import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import type { PopWhatsIncludedItemData } from '@/app/[locale]/product/_types/whatsIncluded';
import Image from '@/app/components/Image';
import RichText from '@/app/components/RichText';

import PopBottomEyebrow from '../PopBottomEyebrow';

export interface PopWhatsIncludedItemProps extends PopWhatsIncludedItemData {
  readonly index: number;
}

const PopWhatsIncludedItem = ({
  description,
  image,
  index,
  title,
}: PopWhatsIncludedItemProps) => {
  const t = useTranslations();

  return (
    <LayoutGrid className="pt-24 lg:items-center">
      <GridItem
        className="mb-14 lg:mb-0"
        colEnd={{ sm: 'main', md: 21, lg: 'main' }}
        colStart={{ sm: 'main', md: 5, lg: 13 }}
      >
        <div className="relative aspect-square overflow-hidden rounded-lg md:aspect-5/4">
          <Image
            localizedAlt={image.alt}
            className="object-cover"
            fill
            format="jpg"
            sizes="(max-width: 767px) 95vw, (max-width: 1023px) 70vw, (max-width: 1567px) 46vw, 720px"
            src={image.src}
          />
        </div>
      </GridItem>
      <GridItem
        rowStart={{ sm: 2, lg: 1 }}
        colEnd={{ sm: 'main', md: 21, lg: 12, xl: 10 }}
        colStart={{ sm: 'main', md: 5, lg: 'main' }}
      >
        {index === 0 && (
          <PopBottomEyebrow className="mb-4 lg:mb-5" Element="h2">
            {t('pop_whats_included_title')}
          </PopBottomEyebrow>
        )}
        <TypographyV3
          className="mb-5 text-5xl tracking-tighter lg:mb-8 xl:text-heading-3xl"
          color="inherit"
          Element="h3"
          weight="light"
        >
          {t(title)}
        </TypographyV3>
        <TypographyV3 color="inherit">
          <RichText messageKey={description} />
        </TypographyV3>
      </GridItem>
    </LayoutGrid>
  );
};

export default PopWhatsIncludedItem;
